import SaveCuadreInventario from "../../shared/componente/save-cuadre-inventario/SaveCuadreInventario";

export default function CreateCuadreInventarioPage() {

  return (
    <SaveCuadreInventario
      label="📝Cuadre de Inventario"
    />
  )
}
